import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import styles from './styles.scss';
import Select from '../Select';
import withValidation from '../../shared/withValidation';

class LabeledIfStatment extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getDisplayValue = this.getDisplayValue.bind(this);
  }

  getDisplayValue() {
    const { value, options } = this.props;

    const displayValue = options.find((val) => {
      return val.value && value ? val.value.toUpperCase() === value.toUpperCase() : false;
    });

    return displayValue ? displayValue.label : value;
  }

  render() {
    const { editMode, label, value, isnLabel, condition, child, options, error } = this.props;

    return (
      <div>
        <FieldLabel isnLabel={isnLabel}>{label}</FieldLabel>
        <Choose>
          <When condition={editMode}>
            <Select {...this.props} value={value} options={options} />
            <If condition={condition}>{child}</If>
          </When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{this.getDisplayValue() || '-'}</label>
            {error && <label className={styles.error}>{error}</label>}
            <If condition={condition}>{child}</If>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LabeledIfStatment.propTypes = {
  editMode: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.string,
  type: PropTypes.string,
  isnLabel: PropTypes.bool,
  condition: PropTypes.bool,
  child: PropTypes.any,
  options: PropTypes.array,
  allowBlank: PropTypes.bool,
  error: PropTypes.string,
};

export default withValidation(LabeledIfStatment);



// WEBPACK FOOTER //
// src/components/shared/LabeledIfStatment/index.jsx